import { DynamicContentType } from '../../types/content.types.js'
import { FileEntryBM } from '../../types/fileEntry.types.js'
import { LucideIconName } from '../../types/lucide.types.js'

export type LogoSectionLogo = {
  image?: FileEntryBM
  name?: string
  link?: string
}

export type LogoSectionData = {
  marginBottom: string
  marginTop: string
  logos: LogoSectionLogo[]
}

const defaultLogo: LogoSectionLogo = {
  image: undefined,
  name: 'Företagets namn',
  link: '/',
}

export const logoSection: DynamicContentType<LogoSectionData> = {
  name: 'logoSection',
  viewName: 'Logotyper',
  featureKey: 'logoSection',
  icon: LucideIconName.WalletCards,
  default: false,
  uuid: '',
  data: {
    logos: [defaultLogo, defaultLogo, defaultLogo, defaultLogo],
    marginBottom: '1rem',
    marginTop: '1rem',
  },
}
